import { useEffect, useState } from 'react';
import VideoRecorder from '../services/VideoRecorder';

const useVideoRecorder = () => {
  const [videoRecorder] = useState(new VideoRecorder());
  const [media, setMedia] = useState<MediaRecorder | null>(null);
  const [state, setState] = useState<RecordingState | null>('inactive');

  useEffect(() => {
    videoRecorder.mediaAttached = (mediaRecorder) => {
      setMedia(mediaRecorder);
    };
  }, [videoRecorder]);

  useEffect(() => {
    function handleStateUpdate() {
      setState(media?.state || null);
    }
    if (media) {
      handleStateUpdate();
      media.addEventListener('onstart', handleStateUpdate);
      media.addEventListener('onpause', handleStateUpdate);
      media.addEventListener('onerror', handleStateUpdate);
      media.addEventListener('onstop', handleStateUpdate);
      media.addEventListener('onresume', handleStateUpdate);
      media.addEventListener('dataavailable', handleStateUpdate);
    }
  }, [media]);

  return [videoRecorder, state] as const;
};

export default useVideoRecorder;
